var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55806 3.20064C9.80214 2.95656 10.1979 2.95656 10.4419 3.20064L17.6831 10.4418C17.9271 10.6858 18.3229 10.6858 18.5669 10.4418C18.811 10.1977 18.811 9.80195 18.5669 9.55787L11.3258 2.31675C10.5936 1.58452 9.40641 1.58452 8.67417 2.31675L1.43306 9.55787C1.18898 9.80195 1.18898 10.1977 1.43306 10.4418C1.67714 10.6858 2.07286 10.6858 2.31694 10.4418L9.55806 3.20064Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.52646L16.7992 11.3256C16.8239 11.3504 16.8492 11.3743 16.875 11.3974V16.5623C16.875 17.4253 16.1754 18.1248 15.3125 18.1248H12.5C12.1548 18.1248 11.875 17.845 11.875 17.4998V13.7498C11.875 13.4046 11.5952 13.1248 11.25 13.1248H8.75C8.40482 13.1248 8.125 13.4046 8.125 13.7498V17.4998C8.125 17.845 7.84518 18.1248 7.5 18.1248H4.6875C3.82456 18.1248 3.125 17.4253 3.125 16.5623V11.3974C3.15077 11.3743 3.17606 11.3504 3.20083 11.3256L10 4.52646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.222431d86255d8efb1c9231a94000b71.svg";
export { ForwardRef as ReactComponent };